



















import { Component, Prop, Vue } from "vue-property-decorator";
import axios from "axios";
const pix: string =
  "https://service-rfwarubo-1251411213.hk.apigw.tencentcs.com/send";
type TrendContent = {
  description: string;
  upload_time: number | string;
  pictures: Array<{
    img_src: string;
    img_height: number;
    img_width: number;
    img_size: number;
    cos: string | null;
  }> | null;
};
type TrendContext = {
  item: TrendContent;
  user: { name: string; head_url: string; uid: number };
  origin: string | TrendContent | null;
};
@Component
export default class extends Vue {
  @Prop({ default: null }) data!: string | null;
  protected trend: TrendContext | null = null;
  protected load: boolean = false;
  created() {
    let trend: TrendContext = JSON.parse(this.data || "");
    if (trend.origin && typeof trend.origin === "string") {
      trend.origin = JSON.parse(trend.origin);
    }
    if (trend.item.upload_time && typeof trend.item.upload_time === "number") {
      trend.item.upload_time = formatUpdateTime(trend.item.upload_time);
    }
    setTimeout(async () => {
      if (trend.item.pictures) {
        let images = trend.item.pictures.map(item => item.img_src);
        let result: Array<string> | string = (
          await axios.post(pix, { images: JSON.stringify(images) })
        ).data;
        if (typeof result === "string") result = JSON.parse(result);

        if (result)
          trend.item.pictures = trend.item.pictures.map(
            (item, k) => (
              (item.cos =
                item.img_size > 850 ? result[k] + "/lighter" : result[k]),
              item
            )
          );
        this.trend = trend;
      }
    });
    console.log((this.trend = trend));
  }
  onload(): void {
    setTimeout(() => (this.load = true), 1000);
  }
}
function formatUpdateTime(timeStemp: number): string {
  let date: Date = new Date(timeStemp * 1000);
  let [year, mouth, day, hours, miniues, seccod] = [
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds()
  ];
  return `${year}-${("00" + mouth).slice(-2)}-${day} ${("00" + hours).slice(
    -2
  )}:${("00" + miniues).slice(-2)}:${("00" + seccod).slice(-2)}`;
}
